import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  Alert,
  AlertTitle,
  AlertDescription,
  Button,
  IconButton,
  Flex,
  useColorModeValue,
  Tooltip,
} from '@chakra-ui/react';
import { FiLogOut } from 'react-icons/fi';
import MySuccessIcon from '../../assets/img/profile/successIcon.svg';
import { useHistory } from 'react-router-dom';
import { authService } from 'services/auth.service';

const ApprovalStatusModal = ({ isOpen, onClose }) => {
  const history = useHistory();
  const iconBg = useColorModeValue('gray.100', 'whiteAlpha.200');
  const iconColor = useColorModeValue('red.500', 'red.400');

  const handleLogout = () => {
    authService.logout();
    history.push('/auth/sign-in');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} isCentered size="lg">
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent 
        padding="3rem 2rem" 
        position="relative"
        maxW="600px"
        boxShadow="xl"
      >
        {/* <Tooltip label="Logout" placement="left">
          <IconButton
            icon={<FiLogOut />}
            position="absolute"
            top="1rem"
            right="1rem"
            variant="ghost"
            colorScheme="gray"
            size="sm"
            aria-label="Logout"
            onClick={handleLogout}
            _hover={{ bg: iconBg }}
            color={iconColor}
          />
        </Tooltip> */}
        
        <Alert
          status="success"
          variant="subtle"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          bg="transparent"
        >
          <Flex 
            justify="center" 
            align="center" 
            mb="1.5rem"
            bg="green.100"
            p="4"
            borderRadius="full"
          >
            <img src={MySuccessIcon} alt="Success Icon" width="32px" />
          </Flex>
          <AlertTitle mb="1rem" fontSize="2xl" fontWeight="bold">
            Waiting for Approval
          </AlertTitle>
          <AlertDescription fontSize="md" color="gray.600" maxW="320px" mb="2rem">
            Your documents have been submitted successfully. We'll notify you once the admin reviews your application.
          </AlertDescription>
          <Button
            colorScheme="red"
            onClick={handleLogout}
            size="md"
            width="auto"
            px="8"
            borderRadius="md"
            leftIcon={<FiLogOut />}
            _hover={{
              bg: 'red.600',
              transform: 'translateY(-1px)',
              boxShadow: 'md'
            }}
            _active={{
              bg: 'red.700',
              transform: 'translateY(0)'
            }}
            transition="all 0.2s"
            fontWeight="medium"
          >
            Sign Out
          </Button>
        </Alert>
      </ModalContent>
    </Modal>
  );
};

export default ApprovalStatusModal;
